import { SkyLink } from "@skypointcloud/skypoint-ui";

/**
 * Whether an address the server built may be offered as a link: `https://`, a Snowflake host,
 * nothing after it. The server builds it from a checked account (`snowflakeAccountUrl`); this is
 * the client's own second check, so a link never opens anything but a Snowflake sign-in page.
 */
export function usableAccountUrl(url: string | null | undefined): url is string {
  if (!url) return false;
  return /^https:\/\/[a-z0-9][a-z0-9.-]*\.snowflakecomputing\.com$/.test(url);
}

/** A private-link account's address works only on the customer's own network. */
export function isPrivateLink(url: string): boolean {
  return url.includes(".privatelink.");
}

/**
 * "Open Snowflake" (ADR 0011): a plain top-level link to the account's sign-in page, in a new
 * tab. No token, no query string, no frame and no prefetch: the person signs in to Snowflake
 * with their own account, and skyData is not part of that sign-in.
 */
export function OpenSnowflakeButton({ accountUrl }: { accountUrl: string }) {
  return (
    <SkyLink
      href={accountUrl}
      target="_blank"
      rel="noopener noreferrer"
      testId="your-data-open-snowflake"
    >
      Open Snowflake
    </SkyLink>
  );
}
